import React, { useState, useRef, useEffect } from 'react';

interface ColumnFilterPopupProps {
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
  anchorRef: React.RefObject<HTMLElement>;
}

const ColumnFilterPopup: React.FC<ColumnFilterPopupProps> = ({ value, onChange, onClose, anchorRef }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
    const handleClickOutside = (event: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target as Node) &&
        anchorRef.current &&
        !anchorRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose, anchorRef]);

  return (
    <div
      className="column-filter-popup"
      style={{
        position: 'absolute',
        top: 0,
        left: 1,
        width: '100%',
        zIndex: 20,
        padding: '0.25rem 0.5rem',
        display: 'flex',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder="Type to filter..."
        className="form-control"
        style={{ minWidth: 80, maxWidth: 'calc(100% - 5em)', fontSize: '0.95em', height: '1.8em', padding: '0 0.5em', marginRight: 0 }}
        onClick={e => e.stopPropagation()}
      />
      {/* The search icon is rendered outside this popup, so no need to reserve space for it here */}
    </div>
  );
};

export default ColumnFilterPopup;
